import Choices from 'choices.js';

const initNode = (node) => {
  node.classList.add('choices_initialized');

  const choices = new Choices(node, {
    placeholderValue: 'Start typing a [whatever]',
    searchFloor: 3,
    shouldSort: false,
    itemSelectText: '',
  });
};

const initAll = () => {
  const nodes = document.querySelectorAll('select:not(.custom-choices):not(.choices_initialized)');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
};

export default { initAll, start };
